import { createContext, useContext, useEffect, useState } from "react";
import { authApi, cityApi } from "@/lib/api";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(
    localStorage.getItem("selected_city") || "jaipur"
  );
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    cityApi.list({ enabled: true }).then(setCities).catch(() => setCities([]));
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) { setLoadingUser(false); return; }
    authApi
      .me()
      .then(setUser)
      .catch(() => {
        localStorage.removeItem("admin_token");
        setUser(null);
      })
      .finally(() => setLoadingUser(false));
  }, []);

  const chooseCity = (key) => {
    setSelectedCity(key);
    localStorage.setItem("selected_city", key);
  };

  const login = async (email, password) => {
    const res = await authApi.login(email, password);
    localStorage.setItem("admin_token", res.token);
    setUser(res.user);
    return res.user;
  };

  const register = async (email, password, name) => {
    const res = await authApi.register(email, password, name);
    localStorage.setItem("admin_token", res.token);
    setUser(res.user);
    return res.user;
  };

  const logout = () => {
    localStorage.removeItem("admin_token");
    setUser(null);
  };

  return (
    <AppContext.Provider
      value={{ cities, selectedCity, chooseCity, user, loadingUser, login, register, logout }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
